import { SendTransactionRequest, TonConnect, UserRejectsError, WalletInfo, isWalletInfoCurrentlyEmbedded,WalletInfoCurrentlyEmbedded} from '@tonconnect/sdk';
import  { TonConnectUI } from '@tonconnect/ui'
import TonWeb from "tonweb";
import {_isMobile} from '@/utils'
const dappMetadata = { manifestUrl: 'https://tonodissiya.com/h5/tonconnect-manifest.json' };

export const connector = new TonConnect(dappMetadata);
// export const provider = window.ton;

export async function sendTransaction(tx,wallet){
    try{
        if ('universalLink' in wallet && ! isWalletInfoCurrentlyEmbedded && _isMobile()) {
			openLink(addReturnStrategy(wallet.universalLink, 'none'), '_blank');
		}
        const result = await connector.sendTransaction(tx)
        // console.log(`Send tx result: ${JSON.stringify(result)}`);
        return result;
    } catch (e){
        let message = 'Send transaction error';
		let description = '';
        if (typeof e === 'object' && e instanceof UserRejectsError) {
			message = 'You rejected the transaction';
			description = 'Please try again and confirm transaction in your wallet.';
            throw e;
		}
    }
}

export const ConnectUI = new TonConnectUI({
    manifestUrl: 'https://tonodissiya.com/h5/tonconnect-manifest.json',
	// buttonRootId: 'ton-connect'
	uiPreferences: {
		language: "en"
	}
});

export const checkedAddr = (member)=>{
         let flag = true
        const currentAccount = ConnectUI.account;
        if(member && currentAccount.address){
            let addr = new TonWeb.utils.Address(currentAccount.address);
            let account = new TonWeb.utils.Address(addr) 
            let chain = parseInt(currentAccount.chain)
            let account1 =''
            if(chain == -239){
                 account1 = account.toString(true, true, false)
            }else{
                 account1 = account.toString(true, true, false, true)
            }
            console.log( member,account1)
        if(member && member.Name){
            if(member.Name != account1){
                flag =  false 
            }
        }
    }
    return flag

}


function openLink(href, target) {
	window.open(href, target, 'noreferrer noopener');
}

export function addReturnStrategy(url, returnStrategy) {
	const link = new URL(url);
	link.searchParams.append('ret', returnStrategy);
	return link.toString();
}

export async function isShowModal (){

    const walletsList = await connector.getWallets();
    // console.log(walletsList)
    const embeddedWallet = walletsList.find(isWalletInfoCurrentlyEmbedded) 
    return new Promise((resolve, reject) => {
        if (embeddedWallet) {
            connector.connect({ jsBridgeKey: embeddedWallet.jsBridgeKey });
            resolve(true)
        }else{
            resolve(false)
        }
    })
}

export function toShowChain(id){
    var chain = parseInt(id)
    if(chain==-3){
        return "TestNet  " + chain.toString()
    }
    if(chain==-239){
        return "MainNet  " + chain.toString()
    }
}